
<div class="calendar-container">
  <div class="calendar">
    @for (item of [].constructor(7); track index; let index = $index) {
      <div class="calenar-header">
        {{ index | weekday }}
      </div>
    }
    @for (offsetDay of offsetDays; track offsetDay) {
      <div class="offset-day"></div>
    }
    @for (date of calendarData; track date.day.unix()) {
      <div
        class="day"
      [ngClass]="{
         'day--holiday-cz': date.isCzechHoliday,
         'day--estate-trade-day': date.isEstateTradeDay,
         'day--holiday-other': date.isUsBankHoliday || date.isUkWalesBankHoliday,
         'day--trade-day': date.isTradeDay && !date.isEstateTradeDay,
         'day--saturday': date.day.day() === 6,
         'day--sunday': date.day.day() === 0
      }"
        >
        {{ date.day.get('date') }}
      </div>
    }
  </div>

  <div class="calendar-legend">
    @for (dateType of dayTypes; track dateType) {
      <div class="legend-item">
        <div class="legend-item-label" [ngClass]="'legend-item-label--' + dateType">
          {{ 'calendar.dayTypes.' + dateType | translate }}
        </div>
      </div>
    }
  </div>
</div>